import React from "react";
import { createRoot } from 'react-dom/client';
import './index.css'
import App from './App';

import { ContextProvider } from "./contexts/ContextProvider";

// ReactDOM.render(
//     <App />,
//     document.getElementById('root')
// );

const container = document.getElementById('root')
const app = createRoot(container)
app.render(
    <ContextProvider>
          <App />
    </ContextProvider>
  
    );